import { useMemo } from 'react';

import { ColumnDef } from '@tanstack/react-table';

interface Package {
    OS: string;
    OSVersion: string;
    arch: string;
    packageName: string;
    packageVersion: string;
    packageFilename: string;
}

export default function usePackagesTableData(packages: Package[]) {
    const data = useMemo(() => packages ?? [], [packages]);

    const columns = useMemo<ColumnDef<(typeof data)[number]>[]>(
        () => [
            {
                header: 'OS',
                accessorFn: ({ OS }) => OS,
                minSize: 100,
                cell: (info) => info.renderValue()
            },
            {
                header: 'OS Version',
                accessorFn: ({ OSVersion }) => OSVersion,
                minSize: 100,
                cell: (info) => info.renderValue()
            },
            {
                header: 'Architecture',
                accessorFn: ({ arch }) => arch,
                minSize: 100,
                cell: (info) => info.renderValue()
            },
            {
                header: 'Package',
                accessorFn: ({ packageName }) => packageName,
                minSize: 100,
                cell: (info) => info.renderValue()
            },
            {
                header: 'Package Version',
                accessorFn: ({ packageVersion }) => packageVersion,
                minSize: 100,
                cell: (info) => info.renderValue()
            },
            {
                header: 'Filename',
                accessorFn: ({ packageFilename }) => packageFilename,
                minSize: 100,
                cell: (info) => info.renderValue()
            }
        ],
        []
    );

    return { data, columns };
}
